import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import debounce, { buildLink, getLinkId } from 'Services/tools';
import { fetchTeamId, searchTeams, searchTeamsInCompetition } from './actions';
import ClubIcon from "../../common/components/icons/Club";

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: '10',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    left: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

@injectIntl
@withStyles(styles)
@connect(store => ({
  results: store.teams.search || [],
}))
export default class TeamInput extends Component {
  state = {
    searchText: '',
    suggestions: [],
  };

  componentDidMount() {
    const { input, dispatch } = this.props;
    if (input.value) {
      const id = getLinkId(input.value);
      dispatch(fetchTeamId(id)).then(({ payload }) => {
        this.setState({
          searchText: this.getLabel(payload),
        });
      });
    }
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { input } = this.props;
    if (!next.input || !input) {
      return true;
    }
    if (input.value != next.input.value && !next.input.value) {
      this.setState({ searchText: '' });
    }
  }

  getLabel = team => {
    let label = team.name;
    if (team.ageGroup && team.ageGroup.code !== 'senior') {
      label += ` ${team.ageGroup.name}`;
    }
    if (team.gender !== 'male') {
      label += ` ${team.genderTranslated}`;
    }

    return label;
  };

  // Optional `competition` prop (IRI or id): restrict suggestions to the teams engaged
  // in the active tournament of that competition instead of the global search.
  handleSuggestionsFetchRequested = debounce(({ value }) => {
    const { dispatch, competition } = this.props;
    const search = competition ? searchTeamsInCompetition(competition, value) : searchTeams(value);
    dispatch(search).then(() => {
      this.setState({
        suggestions: this.getSuggestions(value),
      });
    });
  }, 500);

  handleChange = (event, { newValue }) => {
    this.setState({
      searchText: newValue,
    });
  };
  handleSuggestionSelected = (event, { suggestion }) => {
    const { useObject } = this.props
    if (useObject) {
      this.props.input.onChange(suggestion);
    } else {
      const value = buildLink('Team', suggestion.id);
      this.props.input.onChange(value);
    }
  };

  renderInput = inputProps => {
    const { classes, className, value, ref, label, hintText, ...other } = inputProps;

    return (
      <TextField
        className={className}
        value={value}
        inputRef={ref}
        label={label}
        fullWidth
        InputProps={{
          classes: {
            input: classes.input,
          },
          placeholder: hintText || label,
          startAdornment: (
            <InputAdornment position="start">
              <ClubIcon />
            </InputAdornment>
          ),
          ...other,
        }}
      />
    );
  };
  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const name = this.getLabel(suggestion);
    const matches = match(name, query);
    const parts = parse(name, matches);

    return (
      <MenuItem selected={isHighlighted} component="div">
        <div>
          {parts.map((part, index) =>
            part.highlight ? (
              <span key={index} style={{ fontWeight: 300 }}>
                {part.text}
              </span>
            ) : (
              <strong key={index} style={{ fontWeight: 500 }}>
                {part.text}
              </strong>
            )
          )}
        </div>
      </MenuItem>
    );
  };

  renderSuggestionsContainer = options => {
    const { containerProps, children } = options;

    return (
      <div>
        {children && (
          <Paper {...containerProps} square>
            {children}
          </Paper>
        )}
      </div>
    );
  };

  handleSuggestionsClearRequested = () => {
    if (this.state.searchText == '') this.props.input.onChange(null);
  };

  getSuggestions = value => {
    const { results } = this.props;
    const inputLength = value.trim().length;
    return inputLength === 0 ? [] : results.map(res => res.object);
  };

  render() {
    const {
      input,
      labelKey,
      hintText,
      intl: { formatMessage: f },
      classes,
      className,
    } = this.props;

    const { searchText, suggestions } = this.state;

    const label = labelKey ? f({ id: labelKey }) : f({ id: `field_${input.name}` });

    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
        renderInputComponent={this.renderInput}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={this.getLabel}
        renderSuggestion={this.renderSuggestion}
        inputProps={{
          value: searchText || '',
          onChange: this.handleChange,
          autoFocus: input.autoFocus,
          classes,
          className,
          label,
          hintText,
        }}
      />
    );
  }
}
